<template>
  <div class="Trainee-TS-modal-overlay">
    <div class="Trainee-TS-modal-dialog" @click.stop>
      <div class="Trainee-TS-modal-content">
        <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
        <div class="Trainee-TS-modal-header">
          <h3>{{ signOffType === 'multi' ? 'Multi Date Selection' : 'Sign-Off Date Selection' }}</h3>
          <p v-if="signOffType === 'multi'">
            You are assigning multiple tasks at once. Choose the date that all selected tasks will be performed.
          </p>
          <p v-else>
            You are assigning a single task. Choose the date the task will be performed.
          </p>
        </div>
        <div class="flex justify-center mb-6" style="margin: auto; width: 50%;">
          <VueDatePicker v-model="selectedSignOffDate" :enable-time-picker="false" :format="'dd/MM/yyyy'" placeholder="Select a date" auto-apply />
        </div>
        <div class="button-container">
          <button class="ins-close-button" @click="close">Close</button>
          <div class="right">
            <!-- <button class="ins-save-button" @click="save(1)" :disabled="isSubmitted > 1">Save</button> -->
            <button class="ins-submit-button" @click="handleDateSelection()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import axios from 'axios';
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

export default {
  name: 'ChooseSignOffDateModal',
  components: {
    VueDatePicker,
  },
  props: {
    logbookentryId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    instructorId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    taskId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    logbookId: {
      type: [String, Number],
      required: true,
    },
    signOffType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      selectedSignOffDate: null,
      showChooseSignOffModal: true,
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handleDateSelection() {
      if (!this.selectedSignOffDate) {
        alert('Please select a date.');
        return;
      }
      if (this.signOffType === 'multi') {
        this.$emit('multiDateSelected', this.selectedSignOffDate);
      } else {
        this.$emit('signOffDateSelected', { taskId: this.taskId, selectedDate: this.selectedSignOffDate });
      }
      this.close();
    },
  },
}
</script>

<style scoped>
.Trainee-TS-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  z-index: 1000;
}

.Trainee-TS-modal-body h2 {
  list-style-type: none;
  margin-top: 10px;
  padding: 0;
  margin-right: 1%;
  text-align: center;

}

.Trainee-TS-modal-body ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: left;
  margin-left: 5%;
}

.Trainee-TS-modal-body p.heading {
  list-style-type: none;
  margin-top: 20px;
  text-align: left;
  margin-left: 1%;
}


.Trainee-TS-modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 1000px;
  width: 100%;
  margin: auto;
  padding: 20px;
  border: 1px solid #dddddd;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.Troubleshoot-modal-dialog {
  display: flex;
  flex-direction: row;
  /* Arrange children (questions and answers) in a row */
}

.Trainee-TS-modal-dialog {
  max-height: 90vh;
  overflow-y: auto;
}

button {
  /* Adjust as needed */
  width: 100px;
  /* Adjust as needed */
  padding: 10px;
  /* Adjust as needed */
  background-color: #f2f2f2;
  /* Style as needed */
  border: none;
  /* Style as needed */
  cursor: pointer;
  /* Style as needed */
  /* Add more styling as needed */
}

.right {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  /* Adjust the gap between buttons */
}

.nav-link {
  cursor: pointer;
}

h4 {
  font-size: 1.5rem;
  margin-top: 30px;
  margin-bottom: 30px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin: 20px;
}

.ins-save-button {
  background-color: #007bff;
  color: white;
  border: 1px solid #0157b3;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
}

.ins-save-button:hover {
  background-color: #0462c7;
}

.ins-submit-button {
  background-color: brown;
  border: 1px solid rgb(99, 15, 15);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 20px;
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
}

.ins-close-button:hover {
  background-color: #545a5f;
}

span {
  border: none;
  margin-left: 5px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

div[role="dialog"] {
  animation: fadeIn 0.25s ease-out;
}
</style>